import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Plus } from 'lucide-react';
import { AddListingModal } from '../Listings/AddListingModal';
import { SubscriptionModal } from '../Subscription/SubscriptionModal';
import { isProfessional } from '../../lib/auth/authService';
import { useAuthProfile } from '../../contexts/AuthProfileContext';

export function FloatingActionButton() {
  const location = useLocation();
  const { isAuthenticated, user, profile } = useAuthProfile();
  const [showModal, setShowModal] = useState(false);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [canCreateListing, setCanCreateListing] = useState(false);
  const [ready, setReady] = useState(false);
  const username = profile?.username ?? null;

  useEffect(() => {
    let isCancelled = false;

    const checkProfessionalAccess = async () => {
      if (!isAuthenticated) {
        setCanCreateListing(false);
        setReady(true);
        return;
      }

      const pro = await isProfessional();
      if (!isCancelled) {
        setCanCreateListing(pro);
        setReady(true);
      }
    };

    checkProfessionalAccess();

    return () => {
      isCancelled = true;
    };
  }, [isAuthenticated, user?.id]);

  const isOwnProfile = username && location.pathname.startsWith(`/profile/${username}`);

  // Show FAB only on mobile, only on own profile, only for listings (practitioner/event/venue/job)
  const shouldShow = ready && isAuthenticated && canCreateListing && isOwnProfile;

  if (!shouldShow) return null;

  const handleClick = () => {
    if (canCreateListing) {
      setShowModal(true);
    } else {
      setShowUpgradeModal(true);
    }
  };

  return (
    <>
      {/* Mobile only: + button for adding a listing */}
      <button
        onClick={handleClick}
        className="fixed bottom-24 right-4 z-40 lg:hidden flex w-14 h-14 bg-accent-text text-white rounded-full shadow-lg shadow-accent-text/30 items-center justify-center active:scale-90 transition-all duration-150 hover:shadow-xl hover:shadow-accent-text/40"
        aria-label="Add listing"
      >
        <Plus className="h-6 w-6" />
      </button>

      {showModal && canCreateListing && (
        <AddListingModal
          onClose={() => setShowModal(false)}
          onSuccess={() => {
            setShowModal(false);
          }}
        />
      )}

      {showUpgradeModal && (
        <SubscriptionModal
          onClose={() => setShowUpgradeModal(false)}
          onSuccess={() => {
            setShowUpgradeModal(false);
          }}
        />
      )}
    </>
  );
}
